export default __webpack_public_path__ + "static/media/sailor.9ea94ad1.png";